import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d470a64c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body p-10 p-lg-20" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Espace enseignant"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fw-semibold fs-6" }, " Utilisez l'email et le mot de passe que vous avez reçu par mail . ")
], -1))
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Email ou nom d'utilisateur", -1))
const _hoisted_5 = { class: "fv-plugins-message-container" }
const _hoisted_6 = { class: "fv-help-block" }
const _hoisted_7 = { class: "fv-row mb-5" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-2" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0" }, "Mot de passe")
], -1))
const _hoisted_9 = { class: "fv-plugins-message-container" }
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { class: "d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mt-0" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "link-primary" }, "Mot de passe oublié?", -1))
const _hoisted_14 = { class: "fv-row mb-7" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "symbol symbol-50px me-3" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_19 = { class: "text-gray-800 fw-bold text-hover-primary mb-1 fs-6" }
const _hoisted_20 = { class: "text-gray-400 fw-semibold d-block fs-7" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "symbol symbol-50px me-3" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_25 = { class: "text-gray-800 fw-bold text-hover-primary mb-1 fs-6" }
const _hoisted_26 = { class: "text-gray-400 fw-semibold d-block fs-7" }
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "form-check mt-1 mb-1" }
const _hoisted_30 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_31 = ["href"]
const _hoisted_32 = { class: "text-center mt-5" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Continuer ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Attendez s'il vous plait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form",
      id: "kt_login_signin_form",
      onSubmit: _ctx.onSubmitLogin,
      "validation-schema": _ctx.login
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Field, {
            class: "form-control bg-transparent",
            type: "text",
            name: "email",
            autocomplete: "off"
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_ErrorMessage, { name: "email" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_Field, {
            class: "form-control bg-transparent",
            type: "password",
            name: "password",
            autocomplete: "off"
          }),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_ErrorMessage, { name: "password" })
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_router_link, { to: "/password-forgot" }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_v_select, {
            modelValue: _ctx.selectedDB,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDB) = $event)),
            options: _ctx.options,
            placeholder: "Choisissez votre école",
            "get-option-label": (option) => option.name
          }, {
            option: _withCtx(({ name, logo, adress }) => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("img", {
                    src: logo,
                    class: "",
                    alt: ""
                  }, null, 8, _hoisted_17)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(name), 1),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(adress), 1)
                ])
              ])
            ]),
            "selected-option": _withCtx(({ name, logo, adress }) => [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("img", {
                    src: logo,
                    class: "",
                    alt: ""
                  }, null, 8, _hoisted_23)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(name), 1),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(adress), 1)
                ])
              ])
            ]),
            "no-options": _withCtx(({ search, searching, loading }) => [
              _createTextVNode(" L'école n'est pas enregistrée sur la plate-forme Ed Trust ! ")
            ]),
            _: 1
          }, 8, ["modelValue", "options", "get-option-label"]),
          _createVNode(_component_Field, {
            type: "hidden",
            modelValue: _ctx.selectedDB,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDB) = $event)),
            name: "schoolName"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_ErrorMessage, { name: "schoolName" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.acceptedTerms = !_ctx.acceptedTerms)),
            id: "flexCheckDefault"
          }, null, 32),
          _createElementVNode("label", _hoisted_30, [
            _createTextVNode(_toDisplayString(_ctx.$t('readAndAccept')) + " ", 1),
            _createElementVNode("a", {
              href: _ctx.termsLink,
              target: "_blank",
              class: "terms-link"
            }, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$t('termsAndConditions')) + ".", 1)
            ], 8, _hoisted_31)
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("button", {
            type: "submit",
            ref: "submitButton",
            disabled: !_ctx.acceptedTerms,
            id: "kt_sign_in_submit",
            class: "btn btn-lg btn-primary w-100 mb-5"
          }, _hoisted_36, 8, _hoisted_33)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}